import Vue from "vue";
import base from "../../baseCore";

export default Object.assign(
    {
      apiUrl: `/account/captive-style`,

      async list() {
        return Vue.http.get(this.url(`/`));
      },

      async default() {
        return Vue.http.get(this.url(`/default`));
      },

      async create(payload) {
        return Vue.http.post(this.url(`/`), payload);
      },

      async edit({
        styleId,
        data: {
          name,
          isDefault,
          isDefaultGreen,
          registerStyle,
          logo,
          phraseLogin,
          registerBackground,
          registerBackgroundDesktop,
          localItemFilter,
          ssidFilter,
          allSsidSelected
        }
      }) {
        return Vue.http.put(this.url(`/${styleId}`), {
          name,
          isDefault,
          isDefaultGreen,
          registerStyle,
          logo,
          phraseLogin,
          registerBackground,
          registerBackgroundDesktop,
          localItemFilter,
          ssidFilter,
          allSsidSelected
        });
      },

      async locals({ styleId }) {
        return Vue.http.get(this.url(`/${styleId}/filtro/open/local`));
      },

      async get({ styleId }) {
        return Vue.http.get(this.url(`/${styleId}`));
      },

      async delete({ styleId }) {
        return Vue.http.delete(this.url(`/${styleId}`));
      },

      async logo({ styleId, file }) {
        const formData = new FormData();
        formData.append("file", file);

        return Vue.http.post(this.url(`/${styleId}/logo`), formData);
      },

      async background({ styleId, file, isMobile }) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append('isMobile', isMobile);

        return Vue.http.post(this.url(`/${styleId}/background`), formData);
      }
    },
    base
);
